import React from 'react'

import { faUserFriends } from '@fortawesome/pro-regular-svg-icons'
import { faFerrisWheel, faMapMarkerAlt, faVideo } from '@fortawesome/pro-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import cn from 'classnames'
import { find, get } from 'lodash'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'

import VisitOpening from '.'
import { isShortDuration } from '../durationHelper'
import './WeekView.scss'
import requiredPropTypes from './requiredPropTypes'

export const WeekView = (props) => {
  const { event, scid, userId } = props
  const isMultiEvent = get(event, 'Type') === 'multi'
  const isCollegeFair = get(event, 'CollegeFair', false)
  const participant = find(get(event, 'Participants', []), { Scid: scid })
  const myRep = find(get(participant, 'Representatives', []), { UserId: userId })
  const isPending = get(myRep, 'SystemState') === 'pending_state'
  const virtual = get(event, 'Virtual', false)
  const allowRepLocationType = get(event, 'AllowRepLocationType', false)
  const visitTypeIcon = () => {
    if (allowRepLocationType) {
      return null
    } else if (virtual) {
      return <FontAwesomeIcon icon={faVideo} />
    } else {
      return <FontAwesomeIcon icon={faMapMarkerAlt} />
    }
  }
  return (
    <VisitOpening
      {...props}
      className={cn('week', {
        'short-duration': isShortDuration(event),
        'pending-event-summary': isPending,
      })}
      summary={
        <React.Fragment>
          {isPending ? (
            <strong>Pending Request</strong>
          ) : (
            <>
              <div>
                <strong className="visit-title">
                  {isMultiEvent ? (
                    isCollegeFair ? (
                      <span>
                        <FontAwesomeIcon icon={faFerrisWheel} /> College Fair
                      </span>
                    ) : (
                      <span>
                        <FontAwesomeIcon
                          icon={faUserFriends}
                          className="slot-icon"
                        />{' '}
                        Multi-
                      </span>
                    )
                  ) : (
                    <span>{visitTypeIcon()} </span>
                  )}
                  {!isCollegeFair && <span>Visit Availability </span>}
                </strong>
              </div>
              <div className="high-school-name">
                <span>{event.HighSchoolName}</span>
              </div>
            </>
          )}
        </React.Fragment>
      }
    />
  )
}
WeekView.propTypes = {
  ...requiredPropTypes,
  userId: PropTypes.string.isRequired,
  scid: PropTypes.number.isRequired,
}

export default connect((store) => ({
  userId: store.user.record.Id,
  scid: store.user.record.Scid,
}))(WeekView)
